import Box from "@mui/material/Box";
import FormInput from "../forms/FormInput";
import AppForm from "../forms/AppForm";
import { Divider, TextField } from "@mui/material";
import AppButton from "../common/AppButton";
import { addSpecilitiesValidationSchema } from "../forms/validationSchemas";
import { addSpecialityInitialValues } from "../forms/initialValues";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import LoadingSpinner from "../common/Loading";
import { registerspecilities } from "../../features/speciality/specialitySlice";

interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  getSpecialities: () => void;
}
const SpecialityAddModal = ({
  handleClose,
  setOpenSnackbar,
  getSpecialities,
}: IProps) => {
  const dispatch = useAppDispatch();
  const { isSpecialitiesLoading } = useAppSelector((state) => state.speciality);

  /* ....................................................Specialties Edit Api Cal....................................................... */

  const handleSubmit = (values: any) => {
    dispatch(registerspecilities(values)).then((res: any) => {
      if (res.payload.success === true) {
        getSpecialities();
        setOpenSnackbar();
        handleClose();
      }
    });
  };
  return (
    <>
      <AppForm
        validationSchema={addSpecilitiesValidationSchema}
        initialValues={addSpecialityInitialValues}
        onSubmit={handleSubmit}
      >
        {isSpecialitiesLoading ? (
          <LoadingSpinner style={{ minHeight: "58vh" }} />
        ) : (
          <Box
            sx={{
              px: 2,
              pt: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box sx={{ width: "100%", mt: 3 }}>
              <FormInput name="name" as={TextField} label="Name" fullWidth />
            </Box>

            <Box sx={{ width: "100%", mt: 3 }}>
              <FormInput
                name="description"
                as={TextField}
                label="Description"
                fullWidth
              />

              <Box sx={{ width: "100%", mt: 5 }}>
                <Divider />
                <AppButton
                  title="Add"
                  sx={{ float: "right", margin: "10px" }}
                />
              </Box>
            </Box>
          </Box>
        )}
      </AppForm>
      {/* <AppSnackbar
        message="Successfully Registered!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar()} /> */}
    </>
  );
};

export default SpecialityAddModal;
